const deepfind = (object, path) => {
  let result = object;
  let pathStr = path.replace(/\[(\w+)\]/g, '.$1');
  pathStr = pathStr.replace(/^\./, '');
  const array = pathStr.split('.');
  for (let i = 0; i < array.length; i += 1) {
    const key = array[i];
    if (key in result) {
      result = result[key];
    } else {
      return false;
    }
  }
  return result;
};

export default function checkMenuOptions(menu, configurations) {
  if (menu) {
    return menu.filter(element =>
      (element.feature ? this.$hasFeature(element.feature) : true) &&
      (element.permission ? this.$hasPermission(element.permission) : true) &&
      (element.dashboard_permission ? this.$hasDashboardPermission(element.dashboard_permission)
        : true) &&
      (element.client_config ? deepfind(configurations, element.client_config) : true),
    );
  }
  return [];
}
